import React from 'react'

const AttentionIcon = (
  <>
    <g clipPath="url(#clip0_1077_1909)">
      <path
        d="M8.00002 12C8.18412 12 8.33335 11.8508 8.33335 11.6667C8.33335 11.4826 8.18412 11.3334 8.00002 11.3334C7.81593 11.3334 7.66669 11.4826 7.66669 11.6667C7.66669 11.8508 7.81593 12 8.00002 12Z"
        fill="#FF3366"
      />
      <path
        d="M8.00002 15.3334C12.0501 15.3334 15.3334 12.0501 15.3334 8.00002C15.3334 3.94993 12.0501 0.666687 8.00002 0.666687C3.94993 0.666687 0.666687 3.94993 0.666687 8.00002C0.666687 12.0501 3.94993 15.3334 8.00002 15.3334Z"
        stroke="#FF3366"
        strokeWidth="1.33333"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
      <path
        d="M8 4V9.33333"
        stroke="#FF3366"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00002 12C8.18412 12 8.33335 11.8508 8.33335 11.6667C8.33335 11.4826 8.18412 11.3334 8.00002 11.3334C7.81593 11.3334 7.66669 11.4826 7.66669 11.6667C7.66669 11.8508 7.81593 12 8.00002 12Z"
        stroke="#FF3366"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1077_1909">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </>
)

export default AttentionIcon
